/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	function webpackJsonpCallback(data) {
/******/ 		var chunkIds = data[0];
/******/ 		var moreModules = data[1];
/******/ 		var executeModules = data[2];
/******/
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(data);
/******/
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 		// add entry modules from loaded chunk to deferred list
/******/ 		deferredModules.push.apply(deferredModules, executeModules || []);
/******/
/******/ 		// run deferred modules when all chunks ready
/******/ 		return checkDeferredModules();
/******/ 	};
/******/ 	function checkDeferredModules() {
/******/ 		var result;
/******/ 		for(var i = 0; i < deferredModules.length; i++) {
/******/ 			var deferredModule = deferredModules[i];
/******/ 			var fulfilled = true;
/******/ 			for(var j = 1; j < deferredModule.length; j++) {
/******/ 				var depId = deferredModule[j];
/******/ 				if(installedChunks[depId] !== 0) fulfilled = false;
/******/ 			}
/******/ 			if(fulfilled) {
/******/ 				deferredModules.splice(i--, 1);
/******/ 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
/******/ 			}
/******/ 		}
/******/ 		return result;
/******/ 	}
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 	// Promise = chunk loading, 0 = chunk loaded
/******/ 	var installedChunks = {
/******/ 		"app": 0
/******/ 	};
/******/
/******/ 	var deferredModules = [];
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
/******/ 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
/******/ 	jsonpArray.push = webpackJsonpCallback;
/******/ 	jsonpArray = jsonpArray.slice();
/******/ 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
/******/ 	var parentJsonpFunction = oldJsonpFunction;
/******/
/******/
/******/ 	// add entry module to deferred list
/******/ 	deferredModules.push(["./src/js/app.js","vendor"]);
/******/ 	// run deferred modules when ready
/******/ 	return checkDeferredModules();
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/js/app.js":
/*!***********************!*\
  !*** ./src/js/app.js ***!
  \***********************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _addClassWithScroll = __webpack_require__(/*! ./modules/addClassWithScroll */ "./src/js/modules/addClassWithScroll.js");

var _addClassWithScroll2 = _interopRequireDefault(_addClassWithScroll);

var _addClassWithScrollFunction = __webpack_require__(/*! ./modules/addClassWithScrollFunction */ "./src/js/modules/addClassWithScrollFunction.js");

var _addClassWithScrollFunction2 = _interopRequireDefault(_addClassWithScrollFunction);

var _isMobile = __webpack_require__(/*! ./modules/isMobile.js */ "./src/js/modules/isMobile.js");

var _isMobile2 = _interopRequireDefault(_isMobile);

var _rellax = __webpack_require__(/*! rellax */ "./node_modules/rellax/rellax.js");

var _rellax2 = _interopRequireDefault(_rellax);

var _remodal = __webpack_require__(/*! remodal */ "./node_modules/remodal/dist/remodal.js");

var _remodal2 = _interopRequireDefault(_remodal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pageTop = function pageTop() {
  $("#pageTop").on("click", function () {
    $("body,html").animate({
      scrollTop: 0
    }, 500);
    return false;
  });
};
var toggleMenu = function toggleMenu() {
  $("#toggle-menu").on("click", function (e) {
    e.preventDefault();
    // メニューをトグル
    $("#toggle-menu").toggleClass("active");
    $("#glonav").toggle();
    if ($("#toggle-menu").hasClass("active")) {
      // bodyをfixed前に、メニューバーを開いた瞬間のスクロール位置を変数に保存
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      sessionStorage.setItem("scrollTopMenu", scrollTop);

      // position: fixed;でbodyのスクロールを禁止。スクロール位置もそのままで固定
      $("body").css({ position: "fixed", top: -scrollTop });

      // スクロール位置をセット
      $("body, html").scrollTop(scrollTop);

      $("body").append('<div id="overlay" class="overlay"></div>');

      $("#menu").addClass("on");
      $(".js-header").addClass("on");

      $("#overlay").on("click", function () {
        $("#toggle-menu").toggleClass("active");

        $("body").css({ position: "static", top: 0 });
        $("body, html").scrollTop(sessionStorage.getItem("scrollTopMenu"));
        $("body").find("#overlay").remove();

        $("#menu").removeClass("on");
        $(".js-header").removeClass("on");
      });
    } else {
      // もとに戻す
      $("body").css({
        position: "static",
        top: 0
      });
      // スクロール位置をセット
      $("body, html").scrollTop(sessionStorage.getItem("scrollTopMenu"));

      // オーバーレイを削除
      $("body").find("#overlay").remove();

      $("#menu").removeClass("on");
      $(".js-header").removeClass("on");
    }
  });
};

{
  // console.log('即時実行');
  pageTop();
  toggleMenu();

  $("[data-remodal-id=modal-program]").remodal();

  /**
   * クリックされた要素のインデックスを格納
   */
  $(".program-schedule__btn").on("click", function (event) {
    sessionStorage.setItem("scrollTop", $(window).scrollTop());
  });

  /**
   * モーダル表示開始
   */
  $(document).on("opening", ".remodal-program", function (event) {
    $("body, html").scrollTop(sessionStorage.getItem("scrollTop"));
  });

  /**
   * モーダル非表示完了イベントハンドラ
   */
  $(document).on("closed", ".remodal-program", function () {
    $("body, html").scrollTop(sessionStorage.getItem("scrollTop"));
  });

  // #にダブルクォーテーションが必要
  $('a[href^="#"]').click(function () {
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? "html" : href);
    var position = 0;
    if (href === "#global_nav") {
      // $("body,html").animate({ scrollTop: 0 }, speed, "swing");
      return;
    }
    $("#toggle-menu").toggleClass("active");
    $("body").css({
      position: "static",
      top: 0
    });

    $("body, html").scrollTop(sessionStorage.getItem("scrollTopMenu"));
    $("body").find("#overlay").remove();

    $("#menu").removeClass("on");
    $(".js-header").removeClass("on");
    var speed = 400;

    if ((0, _isMobile2.default)() == false) {
      position = target.offset().top - 80;
    } else {
      position = target.offset().top - 40;
    }

    if (href === "#link-top") {
      position = 0;
    }

    $("body,html").animate({ scrollTop: position }, speed, "swing");

    return false;
  });
  if ((0, _isMobile2.default)() == false) {
    var rellax = new _rellax2.default(".rellax");
  }

  // IEのスムーススクロールをoffにする
  if (navigator.userAgent.match(/MSIE 10/i) || navigator.userAgent.match(/Trident\/7\./) || navigator.userAgent.match(/Edge\/12\./)) {
    $("body").on("mousewheel", function () {
      event.preventDefault();
      var wd = event.wheelDelta;
      var csp = window.pageYOffset;
      window.scrollTo(0, csp - wd);
    });
  }

  splitWord();
}

/**
 * トップへ戻るボタンの表示切り替え
 */
var switchTopPage = function switchTopPage() {
  var $gotop = $(".pagetop");
  if ((0, _isMobile2.default)() == false) {
    if ($(window).scrollTop() > 5000) {
      $gotop.fadeIn(200);
    } else {
      $gotop.fadeOut(100);
    }
  } else {
    if ($(window).scrollTop() > 6000) {
      $gotop.fadeIn(0);
    } else {
      $gotop.fadeOut(0);
    }
  }
};

window.addEventListener("scroll", function () {
  addClassWithScrollImgLeft(".js-scroll-01", "fix", ".step-content--left");
  addClassWithScrollImg(".js-scroll-02", "fix", ".step-content__pic--01");
  addClassWithScrollImg(".js-scroll-03", "fix", ".step-content__pic--02");
  addClassWithScrollImg(".js-scroll-04", "fix", ".step-content__pic--03");
  addClassWithScrollImg(".js-scroll-05", "fix", ".step-content__pic--04");
  (0, _addClassWithScroll2.default)(".fadein", "on");
  (0, _addClassWithScroll2.default)(".mv-desc-content__ttl-wrap", "on");

  addClassWithScrollHeader(".js-header", "fix", ".header");
  // 一文字づつフェードで表示
  (0, _addClassWithScrollFunction2.default)(".mv-desc-content", typingWordAnimation);

  switchTopPage();
}, false);

/**
 * 一文字づつフェードアニメーションを実行する
 */
function typingWordAnimation() {
  // ここから一文字ずつフェードインさせる記述
  $(".typ").css({
    opacity: 1
  });
  var length = $(".typ").children().length;
  for (var i = 0; i <= length; i++) {
    $(".typ").children("span:eq(" + i + ")").delay(25 * i).animate({ opacity: 1 }, 10);
  }
}

/**
 * 文字列をspanで囲んで分割する
 */
function splitWord() {
  // セレクタ配下の要素の文字列をすべて取得
  var textList = $(".typ").children().addBack().contents();

  textList.each(function () {
    if (this.nodeType == 3) {
      // nodeがテキストの場合
      // 文字列を一文字づつspanで囲むように置き換える
      $(this).replaceWith($(this).text().replace(/(\S)/g, "<span>$1</span>"));
    }
  });
}

/**
 * 指定した位置まで要素がスクロールした時に、classを追加する
 *
 * @param selector クラスを追加したい要素
 * @param className 追加したいクラス名
 */
function addClassWithScrollImg(selector, className, addSelector) {
  var elements = document.querySelectorAll(selector);
  Array.prototype.forEach.call(elements, function (element, index) {
    // windowの高さ - a
    var windowHeight = window.document.documentElement.clientHeight;

    // 現在のスクロール量
    var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    // 画面左上から要素までの高さ - b
    var rect = element.getBoundingClientRect();
    var offset = rect.top + scrollTop;

    // 要素が画面に表示されるスクロール量(a - b)
    var scrollHeight = offset - windowHeight;

    // 画面の1/4を超えたら、classを追加
    if (scrollTop > scrollHeight + windowHeight / 4) {
      document.querySelector(addSelector).classList.add(className);
    } else {
      document.querySelector(addSelector).classList.remove(className);
    }
  });
}

/**
 * 指定した位置まで要素がスクロールした時に、classを追加する
 *
 * @param selector クラスを追加したい要素
 * @param className 追加したいクラス名
 */
function addClassWithScrollImgLeft(selector, className, addSelector) {
  var elements = document.querySelectorAll(selector);
  Array.prototype.forEach.call(elements, function (element, index) {
    // windowの高さ - a
    var windowHeight = window.document.documentElement.clientHeight;

    // 現在のスクロール量
    var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    // 画面左上から要素までの高さ - b
    var rect = element.getBoundingClientRect();
    var offset = rect.top + scrollTop;

    // 要素が画面に表示されるスクロール量(a - b)
    var scrollHeight = offset - windowHeight;

    // 画面の1/4を超えたら、classを追加
    if (scrollTop > scrollHeight + windowHeight - 84) {
      document.querySelector(addSelector).classList.add(className);
    } else {
      document.querySelector(addSelector).classList.remove(className);
    }
  });
}

/**
 * 指定した位置まで要素がスクロールした時に、classを追加する
 *
 * @param selector クラスを追加したい要素
 * @param className 追加したいクラス名
 */
function addClassWithScrollHeader(selector, className, addSelector) {
  var elements = document.querySelectorAll(selector);
  Array.prototype.forEach.call(elements, function (element, index) {
    // windowの高さ - a
    var windowHeight = window.document.documentElement.clientHeight;

    // 現在のスクロール量
    var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    // 画面左上から要素までの高さ - b
    var rect = element.getBoundingClientRect();
    var offset = rect.top + scrollTop;

    // 要素が画面に表示されるスクロール量(a - b)
    var scrollHeight = offset - windowHeight;

    // 画面の1/4を超えたら、classを追加
    if (scrollTop > 100) {
      document.querySelector(addSelector).classList.add(className);
    } else {
      document.querySelector(addSelector).classList.remove(className);
    }
  });
}
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./src/js/modules/addClassWithScroll.js":
/*!**********************************************!*\
  !*** ./src/js/modules/addClassWithScroll.js ***!
  \**********************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
"use scrict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addClassWithScroll;

var _isMobile = __webpack_require__(/*! ./isMobile.js */ "./src/js/modules/isMobile.js");

var _isMobile2 = _interopRequireDefault(_isMobile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 指定した位置まで要素がスクロールした時に、classを追加する
 *
 * @param selector クラスを追加したい要素
 * @param className 追加したいクラス名
 */
function addClassWithScroll(selector, className) {
  $(selector).each(function () {
    // 画面左上から要素までの高さ - b
    var offset = $(this).offset().top;
    // 要素が画面に表示されるスクロール量(a - b)
    var scrollHeight = getScrollHeight(offset, getWindowHeight());

    // 画面の1/4を超えたら、classを追加
    var param = 0;
    if ((0, _isMobile2.default)() == false) {
      param = scrollHeight + getWindowHeight() / 4;
    } else {
      param = scrollHeight + getWindowHeight() / 8;
    }
    if (getScrollTop() > param) {
      $(this).addClass(className);
    }
  });
}

var getWindowHeight = function getWindowHeight() {
  return window.document.documentElement.clientHeight;
};
var getScrollTop = function getScrollTop() {
  return document.documentElement.scrollTop || document.body.scrollTop;
};
var getScrollHeight = function getScrollHeight(offset, windowHeight) {
  return offset - windowHeight;
};
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./src/js/modules/addClassWithScrollFunction.js":
/*!******************************************************!*\
  !*** ./src/js/modules/addClassWithScrollFunction.js ***!
  \******************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
"use scrict";

/**
 * 指定した位置まで要素がスクロールした時に、関数を実行する
 *
 * @param selector クラスを追加したい要素
 * @param className 追加したいクラス名
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addClassWithScrollFunction;
function addClassWithScrollFunction(selector, typFunction) {
  $(selector).each(function () {
    // 画面左上から要素までの高さ - b
    var offset = $(this).offset().top;
    // 要素が画面に表示されるスクロール量(a - b)
    var scrollHeight = getScrollHeight(offset, getWindowHeight());

    // 画面の1/4を超えたら、classを追加
    if (getScrollTop() > scrollHeight + getWindowHeight() / 4) {
      typFunction();
    }
  });
}

var getWindowHeight = function getWindowHeight() {
  return window.document.documentElement.clientHeight;
};
var getScrollTop = function getScrollTop() {
  return document.documentElement.scrollTop || document.body.scrollTop;
};
var getScrollHeight = function getScrollHeight(offset, windowHeight) {
  return offset - windowHeight;
};
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./src/js/modules/isMobile.js":
/*!************************************!*\
  !*** ./src/js/modules/isMobile.js ***!
  \************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

'use scrict';

/**
 * モバイル判定
 *
 * return true: モバイル
 * return false: PC
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isMobile;
function isMobile() {
  if (window.matchMedia('(max-width:768px)').matches) {
    return true;
  } else {
    return false;
  }
}

/***/ })

/******/ });
//# sourceMappingURL=app.js.map